// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__knOcJ","label":"styles_label__2BqHu"};